import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import CopyToClipboard from 'react-copy-to-clipboard';
import { DialogContent, DialogActions } from '@material-ui/core';
import { instance } from '../../services/api';
import { Dialog, Button, CopyMessage } from './styles';

interface CurlPanelProps {
  method: string;
  url: string;
  obj: any;
  variable?: string;
  update?: (execute: boolean) => Promise<void>;
}

const CurlPanel: React.FC<CurlPanelProps> = ({ 
  method, 
  url, 
  obj, 
  variable, 
  update 
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [textCopied, setTextCopied] = useState(false);
  const [content, setContent] = useState('');
  const [objText, setObjText] = useState('');

  useEffect(() => {
    try {
      const newObj = { ...obj };

      Object.keys(obj).forEach((key) => {
        if (
          typeof obj[key] === 'object' && 
          key !== "update" && 
          key !== "~update" && 
          obj[key]['@assetType']
        ) {
          Object.keys(obj[key]).forEach((childKey) => {
            if (!['@assetType', '@key'].includes(childKey)) {
              delete newObj[key][childKey];
            }
          });
        }
      });

      setObjText(JSON.stringify(newObj, null, 2));
    } catch (err) {
      toast.error('Unable to stringify object on curl panel');
    }
  }, [obj]);

  useEffect(() => {
    const baseCommand = variable ? `REQUEST=${variable} && ` : '';
    const baseUrl = `${instance.defaults.baseURL}${url}`;
    const headers = "-H 'Content-Type: application/json' -H 'cache-control: no-cache'";
    const data = objText && objText !== '{}' ? ` -d '${objText}'` : '';

    const curlCommand = `${baseCommand}curl -X ${method} "${baseUrl}" ${headers}${data}`;
    setContent(curlCommand);
  }, [method, objText, variable, url]);

  const handleCopy = () => {
    setTextCopied(true);
    setTimeout(() => setTextCopied(false), 3000);
  };

  return (
    <div>
      <Dialog 
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <div className="MuiDialogTitle-root">
          <h2>
            <i className="bx bx-code-curly" />
            CURL Command
          </h2>
        </div>

        <DialogContent dividers>
          <pre>{content}</pre>
        </DialogContent>

        {textCopied && (
          <DialogContent>
            <CopyMessage>
              <i className="bx bx-check-circle" />
              Command copied to clipboard!
            </CopyMessage>
          </DialogContent>
        )}

        <DialogActions>
          <Button 
            variant="secondary" 
            onClick={() => setOpenDialog(false)}
          >
            Close
          </Button>
          <CopyToClipboard text={content}>
            <Button
              variant="primary"
              onClick={handleCopy}
            >
              <i className="bx bx-copy-alt" />
              Copy
            </Button>
          </CopyToClipboard>
        </DialogActions>
      </Dialog>

      <Button
        variant="secondary"
        onClick={() => {
          if (update) update(false);
          setOpenDialog(true);
        }}
      >
        <i className="bx bx-code-curly" />
        CURL
      </Button>
    </div>
  );
};

export default CurlPanel;